module.exports = __webpack_public_path__ + "static/img/bp2.1b3f908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911263/bp2.jpg
// module id = 0wrP
// module chunks = 1